import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addOrUpdateAccessControl, addOrUpdateCompanyConfiguration, addOrUpdateModuleWiseConfiguration, getAccessControl, getAutoCalculatedTa, getCompanyConfiguration, getExpenseReminder, getModuleWiseConfiguration, getPaymentSystem, getTripApprovalRule, getWhenCanEmployeeSubmitExpenses, getWhenCanExpensesBooked, getYesOrNo } from "../Repository/CompanyRepository";
import { toast } from "react-toastify";
import { showToast } from "../../../../utils/toastUtils";

// Fetch company configuration hook
export const useCompanyConfiguration = ({
    params = {},
    enable = false,
  }: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
      queryKey: ["COMPANY_CONFIGURATION"],
      queryFn:  ()=>getCompanyConfiguration(params),
      enabled: enable,
      retry: false,
    });
  };

  //Add or Update CompanyConfiguration
  export const useAddOrUpdateCompanyConfiguration = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: addOrUpdateCompanyConfiguration,
      onSuccess: (data) => {
        showToast.success("addOrUpdateCompanyConfiguration Successfully!");
        queryClient.invalidateQueries({ queryKey: ["COMPANY_CONFIGURATION"] });
      },
      onError: (error) => {
        showToast.error("Failed to  addOrUpdateCompanyConfiguration!");
      },
    });
  };

// Fetch company configuration hook
export const useAccessControl = ({
    params = {},
    enable = false,
  }: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
      queryKey: ["ACCESS_CONTROLS"],
      queryFn:  ()=>getAccessControl(params),
      enabled: enable,
      retry: false,
    });
  };


//Add or Update Accesscontrols
  export const useAddOrUpdateAccessControls = () => {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: addOrUpdateAccessControl,
      onSuccess: (data) => {
        showToast.success("addOrUpdateAccessControl Successfully!");
        queryClient.invalidateQueries({ queryKey: ["ACCESS_CONTROLS"] });
      },
      onError: (error) => {
        showToast.error("Failed to  addOrUpdateAccessControl!");
      },
    });
  };

  // Fetch ModuleWiseConfiguration hook
  export const useModuleWiseConfiguration = ({
    id,
    enable = false,
  }: { id?: number; enable?: boolean }) => {
    return useQuery({
      queryKey: ["MODULE_WISE_CONFIGURATION", id],
      queryFn: () => getModuleWiseConfiguration(id),
      enabled: enable,
      retry: false,
    });
  };

  // Add or Update ModuleWiseConfiguration
   export const useAddOrUpdateModuleWiseConfiguration = () => {
      const queryClient = useQueryClient();
    
      return useMutation({
        mutationFn: ({id,body,}: {
          id: any;
          body:any;
        }) => addOrUpdateModuleWiseConfiguration(id, body),
        onSuccess: (data) => {
          showToast.success("ModuleWiseConfiguration Update Successfully!");
          queryClient.invalidateQueries({ queryKey: ["MODULE_WISE_CONFIGURATION"] });
        },
        onError: (error) => {
          showToast.error("Failed to Update ModuleWiseConfiguration!");
        },
      });
    };



  // Fetch WHEN_CAN_EMPLOYEE_SUBMIT_EXPENSES hook
export const useWhenCanEmployeeSubmitExpenses = ({
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["WHEN_CAN_EMPLOYEE_SUBMIT_EXPENSES"],
    queryFn:  ()=>getWhenCanEmployeeSubmitExpenses(),
    enabled: enable,
    retry: false,
  });
};
  // Fetch useExpenseReminder hook
export const useExpenseReminder = ({
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["EXPENSE_REMINDER"],
    queryFn:  ()=>getExpenseReminder(),
    enabled: enable,
    retry: false,
  });
};
  // Fetch useExpenseReminder hook
export const useTripApprovalRule = ({
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["TRIP_APPROVAL_RULE"],
    queryFn:  ()=>getTripApprovalRule(),
    enabled: enable,
    retry: false,
  });
};
  // Fetch WhenCanExpensesBooked hook
export const useWhenCanExpensesBooked = ({
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["WHEN_CAN_EXPENSES_BOOKED"],
    queryFn:  ()=>getWhenCanExpensesBooked(),
    enabled: enable,
    retry: false,
  });
};
  // Fetch yesOrNo hook
export const useYesOrNo = ({
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["YES_OR_NO"],
    queryFn:  ()=>getYesOrNo(),
    enabled: enable,
    retry: false,
  });
};
  // Fetch PaymentSystem hook
export const usePaymentSystem = ({
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["PAYMENT_SYSTEM"],
    queryFn:  ()=>getPaymentSystem(),
    enabled: enable,
    retry: false,
  });
};
  // Fetch autoCalculatedTa hook
export const useAutoCalculatedTa = ({
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["AUTO_CALCULATED_TA"],
    queryFn:  ()=>getAutoCalculatedTa(),
    enabled: enable,
    retry: false,
  });
};



